import {LookupTabName, AvaliableTabs} from "./types.d";

export function isValidKindOfTab(x: string): x is AvaliableTabs {
  return Object.keys(LookupTabName).includes(x);
}


